// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/households/stylesheets/households.scss
 ** module id = 447
 ** module chunks = 1
 **/